import React, { useEffect, useState } from "react";

function TestStudents() {
  const [students, setStudents] = useState([]);

  console.log("TestStudents component rendered!");

  useEffect(() => {
    fetch("http://localhost:5000/api/students")
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched students:", data); // Debug line
        setStudents(data);
      })
      .catch((err) => {
        console.error("Error fetching students:", err);
      });
  }, []);

  return (
    <div>
      <h3>Students from Backend:</h3>
      <ul>
        {students.length === 0 ? (
          <li>No students found.</li>
        ) : (
          students.map((student, idx) => (
            <li key={idx}>{student.name} - {student.email}</li>
          ))
        )}
      </ul>
    </div>
  );
}

export default TestStudents;
